import FeatureNotice from "@/v2-backoffice-client/feature/FeatureNotice"

export type FeatureLiveEditNoticeProps = {
  className?: string
}

/**
 * Marks the tabs that do NOT wait for a publish.
 *
 * A feature's text is authored in the catalog and ships with the next
 * translation publish; its configuration and availability write the running
 * environment the moment they are saved. Those two habits sit one tab apart
 * on the same entry, so the faster one says so rather than letting an
 * operator infer it from a toast.
 */
function FeatureLiveEditNotice(props: FeatureLiveEditNoticeProps) {
  const { className } = props

  return (
    <FeatureNotice tone="info" className={className}>
      Saves here go live in this environment immediately and are mirrored to the
      catalog — no publish, unlike the Text tab.
    </FeatureNotice>
  )
}

export default FeatureLiveEditNotice
